// Vocabulario canónico de estado_vigente para los CHIPS DE FILTRO.
// La fuente de verdad del color de cada BADGE es el backend (EstadoDespachoService
// manda {color, bg} en cada fila); esta paleta la espeja para que el chip del
// filtro se vea igual que el badge. Un solo lugar: la usan /logistica/remitos
// (desktop) y /m/logistica (móvil).
export const ESTADO_VIGENTE_OPCIONES = [
  { value: 'ingresado',           label: 'Ingresado',       bg: '#fef3c7', color: '#92400e' },
  { value: 'disponible',          label: 'Disponible',      bg: '#dbeafe', color: '#1e40af' },
  { value: 'en_armado',           label: 'En armado',       bg: '#fef3c7', color: '#92400e' },
  { value: 'en_calle',            label: 'En distribución', bg: '#ede9fe', color: '#5b21b6' },
  { value: 'entregado',           label: 'Entregado',       bg: '#dcfce7', color: '#166534' },
  { value: 'recuperado',          label: 'Recuperado',      bg: '#dcfce7', color: '#166534' },
  { value: 'fallo_sin_reasignar', label: 'Sin reasignar',   bg: '#fee2e2', color: '#991b1b' },
  { value: 'falta_despachar',     label: 'Falta despachar', bg: '#fef3c7', color: '#92400e' },
  { value: 'siniestro',           label: 'Siniestro',       bg: '#fee2e2', color: '#991b1b' },
  { value: 'devolucion_en_camino', label: 'Devolución en camino', bg: '#fee2e2', color: '#991b1b' },
  { value: 'devuelto_deposito',   label: 'Devuelto al depósito', bg: '#f1f5f9', color: '#334155' },
  { value: 'anulado',             label: 'Anulado',         bg: '#fecaca', color: '#7f1d1d' },
]
